import { modifyState } from '~src/state';
import { toggleEditorSidebar, hideSidebarTab } from '~src/sidebarLegacy';
import { getActiveMagicFrameActive } from '~core/magicFrame';

export const handleMagicFramePhotoSelection = async (url) => {
  modifyState('magicFrameSelectPersonPhotoActive', false);
  hideSidebarTab('allegati');
  toggleEditorSidebar();
  const magicFrame = getActiveMagicFrameActive();
  await magicFrame.updatePerson(url);

  magicFrame.scalePersonToWidth(magicFrame.width * magicFrame.scaleX);
  magicFrame.scalePersonToWidth(magicFrame.width * magicFrame.scaleX);
  // scalePersonToWidth has to be called twice or it don't work

  window.canvas.renderAll();
};
